import React from 'react';
import { motion } from 'framer-motion';
import { ShoppingCart } from 'lucide-react';
interface CTAButtonProps {
  text?: string;
  href?: string;
  className?: string;
  isFinal?: boolean;
}
export function CTAButton({
  text = 'SÍ, QUIERO EL KIT INMOBILIARIO PRO',
  href = '#comprar',
  className = '',
  isFinal = false
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (!isFinal && href.startsWith('#')) {
      e.preventDefault();
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  return <motion.a href={href} onClick={handleClick} whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} className={`
        relative inline-flex items-center justify-center gap-3 
        bg-gradient-to-r from-brand-green to-green-500 
        text-white font-heading font-bold text-lg md:text-xl 
        py-4 px-8 rounded-full shadow-[0_0_20px_rgba(34,197,94,0.4)]
        hover:shadow-[0_0_30px_rgba(34,197,94,0.6)] transition-shadow
        animate-pulse-slow text-center w-full md:w-auto
        ${className}
      `} data-id="element-20">
      <ShoppingCart className="w-6 h-6" data-id="element-21" />
      <span data-id="element-22">{text}</span>
    </motion.a>;
}